import { ROLE, USER_RE } from "constant/app";
import get from "lodash/get";
import { defaultObject } from "redux-store/selectors";

// TODO(etsai): Create a Permission util to validate user's right for access.
function isAdmin(user) {
  if (!user) {
    return false;
  }

  return [ROLE.ADMIN, ROLE.SUB_ACCOUNT, ROLE.ADMIN_OPERATOR].includes(
    user.role,
  );
}

function isFullAdmin(user) {
  if (!user) {
    return false;
  }

  return [ROLE.ADMIN, ROLE.SUB_ACCOUNT].includes(user.role);
}

function isOperator(user) {
  if (!user) {
    return false;
  }

  return user.role === ROLE.OPERATOR;
}

function isReadonly(user) {
  if (!user) {
    return true;
  }

  return user.role === ROLE.READ_ONLY;
}

function isSystemUser(user) {
  if (!user) {
    return false;
  }

  return USER_RE.SYSTEM.test(user.email);
}

function isVistarUser(user) {
  if (!user) {
    return false;
  }

  return USER_RE.VISTAR.test(user.email);
}

function isVenueSyncEnabled(user) {
  return get(user, "account.venue_sync_enabled", false);
}

function toString(user, defaultUser = "guest") {
  if (!user) {
    return defaultUser;
  }

  return `${user.name} <${user.email}>`;
}

function usersSelector(state) {
  return get(state, "global.users.byId", defaultObject);
}

export {
  isAdmin,
  isFullAdmin,
  isOperator,
  isReadonly,
  isSystemUser,
  isVenueSyncEnabled,
  isVistarUser,
  toString,
  usersSelector,
};
